module.exports = __webpack_public_path__ + "img/about-us-banner.b6c29f45.png";